import Cookies from 'js-cookie';

import { COUNTRY_CODE_COOKIE_NAME } from '../constants';

/**
 * Get country code from cookie and convert it to 'uk' if it is 'gb'.
 */
export const getCountryCode = () => {
  const countryCode = Cookies.get(COUNTRY_CODE_COOKIE_NAME)?.toLocaleLowerCase();

  return countryCode === 'gb' ? 'uk' : countryCode;
};
